<template>
  <v-container
     fluid
  >
    <v-row>
  <v-col>
    <v-card>
      <v-card-title>
        <h2 class="font-weight-light mb-4">
          {{workOperationName}}
        </h2>
      </v-card-title>
      <v-card-text>
        <v-col>
          {{$t('workOperation.name')}}:
        </v-col>
        <v-col>
          {{workOperationName}}
        </v-col>
      </v-card-text>

    </v-card>
  </v-col>
    </v-row>

    <v-row>
      <v-col>
      <v-btn
        :to="{ name: 'WorkOperationEdit', params: { 'id': id }}">
        {{$t("workOperations.show.edit")}}
      </v-btn>
      </v-col>

    </v-row>



  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'

    export default {
        data() {
            return {
                id:"",
                workOperationName: "",
                search: '',
                headers: [
                    {
                        sortable: true,
                        text: this.$i18n.t("workOperation.name"),
                        value: 'name'
                    }
                ]


            }
        },
        methods: {
            getWorkOperation(workOperationid) {
                api.getWorkOperation(workOperationid).then(response => {
                    this.id = response.id
                    this.workOperationName= response.name


            })
                .catch(error => {
                     this.$store.commit('setErrorMsg', error)
                        console.log(error)
                    //    this.errors.push(error)
                })
            }


        },
        mounted() {
           this.getWorkOperation(this.$route.params.id)
        }
    }
</script>
